import { useListAPIProducts } from 'api/hooks';
import { ReactComponent as APIKeyPlaceholder } from 'assets/api-key-placeholder.svg';
import { ReactComponent as CodeGearIcon } from 'assets/code-sprocket-icon.svg';
import { ReactComponent as UserIcon } from 'assets/user-icon.svg';
import * as React from 'react';
import { APIProductCard } from './APIKeyDetails';
import './ApiKeysCatalogPage.css';
import { Card } from './Card';
import { Loading } from './Loading';

export const ApiKeysCatalogPage = () => {
  const { apiCatalogInfo, apiCatalogInfoError } = useListAPIProducts();

  if (!apiCatalogInfo && !apiCatalogInfoError) {
    return <Loading center />;
  }

  return (
    <div className='px-4 mx-auto api-keys-catalog-container max-w-7xl sm:px-6 lg:px-8'>
      <div className='api-keys-catalog-title'>
        <UserIcon /> My API Product Authentication
      </div>

      <div className='api-keys-list'>
        {apiCatalogInfo?.apiProductsList?.length === 0 && (
          <>
            <Card>
              <div className='empty-card'>
                <div className='empty-card-image-holder text-blue-500gloo'>
                  <CodeGearIcon className='w-16 h-16 fill-current' />
                </div>
                <div className=' empty-card-text'>
                  <div className='empty-card-text-heading'>There are no API Products to display.</div>
                  <div>Contact your portal admin if you feel this is in error.</div>
                </div>
              </div>
            </Card>

            <div style={{ opacity: '.6' }}>
              <APIKeyPlaceholder />
            </div>
            <div style={{ opacity: '.5' }}>
              <APIKeyPlaceholder />
            </div>
            <div className='empty-list-screen' />
          </>
        )}
        {apiCatalogInfo?.apiProductsList?.map(apiProduct => (
          <APIProductCard
            key={apiProduct?.metadata?.uid!}
            apiProductName={apiProduct.metadata?.name!}
            apiProductNamespace={apiProduct.metadata?.namespace!}
            displayName={apiProduct?.displayName}
            description={apiProduct?.description}
          />
        ))}
      </div>
    </div>
  );
};
